import { ResponseV2 } from "@/types/responseV2";
import { apiClientV2 } from "./apiClientV2";
import { ApplicationV2, ApplicationV2Payload } from "@/types/applicationV2";

const getApplicationsV2 = () =>
  apiClientV2.get<ResponseV2<ApplicationV2[]>, ResponseV2<ApplicationV2[]>>(
    "/applications"
  );
const getApplicationV2 = (id: number) =>
  apiClientV2.get<ResponseV2<ApplicationV2>, ResponseV2<ApplicationV2>>(
    `/applications/${id}`
  );

const postApplicationV2 = (payload: ApplicationV2Payload) =>
  apiClientV2.post<ResponseV2<ApplicationV2>, ResponseV2<ApplicationV2>>(
    "/applications",
    payload
  );

const patchApplicationV2 = (id: number, payload: ApplicationV2Payload) =>
  apiClientV2.post<ResponseV2<ApplicationV2>, ResponseV2<ApplicationV2>>(
    `/applications/${id}`,
    payload
  );

export const applications = {
  get: getApplicationV2,
  getAll: getApplicationsV2,
  post: postApplicationV2,
  patch: patchApplicationV2,
};
